import { createReducer } from '@api/createRequestStore';
import { LIST_SCOPE } from './types';

const reducer =  createReducer(LIST_SCOPE);
export default reducer;
